import React, { useState } from 'react';
import CreateButton from './CreateButton';
import PageNavigator from './PageNavigator';
import styles from './UpdatesTabContent.module.css';
import UnitsGrid from './UnitsGrid';
import AddPost from './AddPost';
import ViewPost from './ViewPost';
import mockSwagUpdatesImg from '../assets/images/mock_swag_updates_img.png';
import mockUnitImg from '../assets/images/mock_unit_img.png';

const MOCK_PROJECTS = [
    { id: 1, name: 'Downtown Mall', },
    { id: 2, name: 'Riverside Complex' },
    { id: 3, name: 'Skyline Tower' },
    { id: 4, name: 'Green Valley' },
    { id: 5, name: 'Metro Plaza' },
    { id: 6, name: 'Ocean View' }
];

const MOCK_UNITS_UPDATES_DATA = [
    { id: 1, name: 'Unit 101', project: 'Downtown Mall', date: '2024-06-15', image: mockUnitImg, description: 'New units available in Phase 2 of Downtown Mall project', status: 'available' },
    { id: 2, name: 'Unit 102', project: 'Riverside Complex', date: '2024-06-12', image: mockUnitImg, description: 'Updated pricing for luxury apartments in Riverside Complex', status: 'available' },
    { id: 3, name: 'Unit 103', project: 'Skyline Tower', date: '2024-06-10', image: mockUnitImg, description: 'New floor plans released for Skyline Tower project', status: 'unavailable' },
    { id: 4, name: 'Unit 104', project: 'Green Valley', date: '2024-06-08', image: mockUnitImg, description: 'Construction progress update for Green Valley residential complex', status: 'available' },
    { id: 5, name: 'Unit 105', project: 'Metro Plaza', date: '2024-06-05', image: mockUnitImg, description: 'New commercial units available in Metro Plaza', status: 'available' },
    { id: 6, name: 'Unit 106', project: 'Ocean View', date: '2024-06-03', image: mockUnitImg, description: 'Updated amenities list for Ocean View project', status: 'unavailable' },
    { id: 7, name: 'Unit 107', project: 'Downtown Mall', date: '2024-06-01', image: mockUnitImg, description: 'New phase completion for Downtown Mall', status: 'available' },
    { id: 8, name: 'Unit 108', project: 'Riverside Complex', date: '2024-05-30', image: mockUnitImg, description: 'Updated unit specifications for Riverside Complex', status: 'available' }
];

const MOCK_SWAG_UPDATES_DATA = [
    { id: 1, project: 'Company News', date: '2024-06-15', image: mockSwagUpdatesImg, description: 'New company policies and procedures update' },
    { id: 2, project: 'Team Events', date: '2024-06-12', image: mockSwagUpdatesImg, description: 'Upcoming team building events and activities' },
    { id: 3, project: 'Industry News', date: '2024-06-10', image: mockSwagUpdatesImg, description: 'Latest real estate market trends and insights' },
    { id: 4, project: 'Technology Updates', date: '2024-06-08', image: mockSwagUpdatesImg, description: 'New software features and system improvements' },
    { id: 5, project: 'Training Programs', date: '2024-06-05', image: mockSwagUpdatesImg, description: 'New training opportunities for team members' },
    { id: 6, project: 'Awards & Recognition', date: '2024-06-03', image: mockSwagUpdatesImg, description: 'Recent achievements and company milestones' }
];

const ITEMS_PER_PAGE = 8;

const UpdatesTabContent = ({ selectedTab }) => {
    // Remove all sub-tab and project filter logic
    // Only show the main updates view
    return (
        <div className={styles.updatesContainer}>
            <div className={styles.headerContainer}>
                <div className={styles.headerLeft}>
                    <h2 className={styles.headerTitle}>Updates</h2>
                </div>
            </div>
            {/* Place your main updates grid/component here, e.g. <UnitUpdates ... /> or similar */}
        </div>
    );
};

export default UpdatesTabContent; 